import {
  footerBaseStyle,
  TFooterTheme,
} from '../../base/customComponents/footer';
import { TStyleConfig } from '../../base/types';

export const Footer: TStyleConfig<TFooterTheme> = {
  baseStyle: {
    ...footerBaseStyle,
    footer: {
      ...footerBaseStyle.footer,
      pb: ['0', '6'],
      pt: ['10', null, '6'],
      bg: 'transparent',
      color: 'white',
    },
    stackGap: '1',
    footerBar: {
      display: 'flex',
      flexDir: ['column', null, 'row'],
      h: '70px',
      pr: ['0', null, '3'],
      mb: '0',
      borderRadius: 'md',
      alignItems: 'center',
      justifyContent: ['center', null, 'unset'],
      '& > img': {
        maxW: '250px',
        h: '35px',
        ml: '0',
      },
    },
    footerLink: {
      color: 'beta.500',
      textTransform: 'lowercase',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
    },
    footerLinkTel: {
      color: 'beta.500',
      textTransform: 'lowercase',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
    },
    customFooterLink: {
      color: 'beta.500',
      textTransform: 'capitalize',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
      fontSize: 'base',
    },
    footerLinks: {
      mt: '3',
      ml: ['unset', null, 'auto'],
      pb: ['4', null, '0'],
      alignItems: 'center',
      justifyContent: ['space-around', null, 'unset'],
      color: 'white',
      fontWeight: 'medium',
      flexDir: ['row', null, 'unset'],
      display: 'inline-flex',
    },
    footerContentContainer: {
      px: ['2.5', 'unset'],
      pt: ['3', 'unset'],
      gap: '6',
      ...footerBaseStyle.footerContentContainer,
      bg: [null, null, 'transparent'],
      justifyContent: 'space-between',
      '&': {
        flexDirection: ['column', null, 'column-reverse'],
      },
    },
    nav: {
      ...footerBaseStyle.nav,
      fontSize: 'sm',
      fontWeight: 'medium',
      minW: [null, null, '370px'],
      mt: ['1', 'unset'],
      display: ['flex', 'grid'],
      gridTemplateColumns: '1fr 1fr 1fr',
      gridTemplateRows: 'auto',
      columnGap: '28',
      rowGap: '4',
      alignItems: ['center', 'end'],
      gridTemplateAreas: `
        ". ."
      `,

      '> a': {
        color: 'inherit',
      },
    },
    blurb: {
      ...footerBaseStyle.blurb,
      flex: 'unset',
      textAlign: 'left',
      color: 'white',
      width: 'unset',
      mb: '0',
      ml: [null, '0'],
      mr: [null, null, '4'],
    },
    blurbHeading: {
      ml: 'unset',
      mt: 'unset',
      color: 'white',
    },
    blurbHeadingAge: {
      ...footerBaseStyle.blurbHeadingAge,
      borderColor: 'blackAlpha.50',
      border: '4px',
      mb: '2',
      boxSize: '8',
      fontSize: 'xs',
    },
    blurbHeadingThink: {
      fontSize: 'xs',
      fontWeight: 'bold',
      mb: '4',
    },
    blurbContent: {
      ...footerBaseStyle.blurbContent,
      ml: 'unset',
      mr: [null, null, 'auto'],
      color: 'white',
    },
    copyright: {
      ...footerBaseStyle.copyright,
      textAlign: ['center', 'left'],
      mt: ['7'],
      px: ['8', 'unset'],
      py: '0',
      fontWeight: ['semibold', 'medium'],
      color: 'white',
    },
    container: {
      '&&': {
        px: ['0', '2'],
      },
    },
    emailUs: {
      fontSize: 'md',
      fontWeight: 'bold',
    },
    footerDownloadImage: {
      border: '2px',
      borderColor: 'white',
      borderRadius: 'md',
      filter: 'drop-shadow(0px 2px 7px rgba(0, 0, 0, 0.3))',
    },
    partnerWrapper: {
      mr: 'unset',
    },
    quickLinks: {
      color: ['beta.500', 'white'],
      textTransform: ['uppercase', 'none'],
      textAlign: ['center', 'left'],
      fontSize: ['xs', 'md'],
    },
    ourPartners: {
      fontSize: ['xs', 'md'],
      color: ['beta.500', 'white'],
      textTransform: ['uppercase', 'none'],
    },
    weAccept: {
      fontSize: ['xs', 'md'],
      color: ['beta.500', 'white'],
      textTransform: ['uppercase', 'none'],
    },
  },
  sizes: {},
  variants: {},
};
